import { useFlag, useFlagsStatus, useUnleashClient, useVariant } from '@unleash/proxy-client-react';

/**
 * @typedef {Object} UnleashHook
 * @property {function} isFlagEnabled
 * @property {function} getVariant
 * @property {function} getClient
 * @property {function} getFlagsStatus
 */

/**
 * @name useUnleashHook
 * @param {string} flagName
 * @returns {UnleashHook}
 */
const useUnleashHook = (flagName) => {
  const enabled = useFlag(flagName);
  const unleashClient = useUnleashClient();
  const variant = useVariant(flagName);
  const { flagsReady, flagsError } = useFlagsStatus();

  const isFlagEnabled = () => enabled;
  const getVariant = () => variant;
  const getClient = () => unleashClient;
  const getFlagsStatus = () => ({ flagsReady, flagsError });

  return {
    isFlagEnabled,
    getClient,
    getVariant,
    getFlagsStatus,
  };
};

export default useUnleashHook;
